import { makeActionCreator } from '../../../utilities'
import { SignaturesConstants } from './signatures.constants'

export const setSignatureSection = makeActionCreator(SignaturesConstants.SET_SIGNATURE_SECTION, 'signatureSection')
export const setPatientSignature = makeActionCreator(SignaturesConstants.SET_PATIENT_SIGNATURE, 'patientSignature')
export const setIsMark = makeActionCreator(SignaturesConstants.SET_IS_MARK, 'isMark')
export const setWitnessSignature = makeActionCreator(SignaturesConstants.SET_WITNESS_SIGNATURE, 'witnessSignature')
export const setAmbulanceCrewSignature = makeActionCreator(
  SignaturesConstants.SET_AMBULANCE_CREW_SIGNATURE,
  'ambulanceCrewSignature'
)
export const setRepresentativeSignature = makeActionCreator(
  SignaturesConstants.SET_REPRESENTATIVE_SIGNATURE,
  'representativeSignature'
)
export const setReceivingFacilitySignature = makeActionCreator(
  SignaturesConstants.SET_RECIEVING_FACILITY_SIGNATURE,
  'receivingFacilitySignature'
)
export const setCrewSignature = makeActionCreator(SignaturesConstants.SET_CREW_SIGNATURE, 'crewSignature')
export const setSelectedSignatureType = makeActionCreator(
  SignaturesConstants.SET_SELECTED_SIGNATURE_TYPE,
  'selectedSignatureType'
)
export const saveSignatures = makeActionCreator(SignaturesConstants.SAVE_SIGNATURES, 'signature')
export const deleteSignatureType = makeActionCreator(SignaturesConstants.DELETE_SIGNATURE_TYPE, 'signature')
export const saveTempSignature = makeActionCreator(SignaturesConstants.SAVE_TEMP_SIGNATURE, 'signature')
export const clearTempSignature = makeActionCreator(SignaturesConstants.CLEAR_TEMP_SIGNATURE, 'signature')
export const getSignatures = makeActionCreator(SignaturesConstants.GET_SIGNATURES)
export const resetSignaturesState = makeActionCreator(SignaturesConstants.RESET_STATE)
export const setAttachmentsList = makeActionCreator(SignaturesConstants.SET_ATTACHMENTS_LIST, 'attachments')
export const getAttachments = makeActionCreator(SignaturesConstants.GET_ATTACHMENTS)
export const showConfirmationAlert = makeActionCreator(
  SignaturesConstants.SHOW_CONFIRMATION_ALERT,
  'attachmentId',
  'attachmentType'
)
export const deleteAttachment = makeActionCreator(SignaturesConstants.DELETE_ATTACHMENT)
export const clearAttachments = makeActionCreator(SignaturesConstants.CLEAR_ATTACHMENTS)
export const setFileName = makeActionCreator(SignaturesConstants.SET_FILE_NAME, 'fileName')
export const setPatientPrintedName = makeActionCreator(
  SignaturesConstants.SET_PATIENT_PRINTED_NAME,
  'patientPrintedName'
)
export const setWitnessPrintedName = makeActionCreator(
  SignaturesConstants.SET_WITNESS_PRINTED_NAME,
  'witnessPrintedName'
)
export const setWitnessPhone = makeActionCreator(SignaturesConstants.SET_WITNESS_PHONE, 'witnessPhone')
export const setWitnessAddress = makeActionCreator(SignaturesConstants.SET_WITNESS_ADDRESS, 'witnessAddress')
export const setAmbulancePrintedName = makeActionCreator(
  SignaturesConstants.SET_AMBULANCE_PRINTED_NAME,
  'ambulancePrintedName'
)
export const setRepresentativePrintedName = makeActionCreator(
  SignaturesConstants.SET_REPRESENTATIVE_PRINTED_NAME,
  'representativePrintedName'
)
export const setRepresentativePhone = makeActionCreator(
  SignaturesConstants.SET_REPRESENTATIVE_PHONE,
  'representativePhone'
)
export const setRepresentativeAddress = makeActionCreator(
  SignaturesConstants.SET_REPRESENTATIVE_ADDRESS,
  'representativeAddress'
)
export const setReceivingFacilityPrintedName = makeActionCreator(
  SignaturesConstants.SET_RECEIVING_FACILITY_PRINTED_NAME,
  'receivingFacilityPrintedName'
)
export const setReceivingFacilityTitle = makeActionCreator(
  SignaturesConstants.SET_RECEIVING_FACILITY_TITLE,
  'receivingFacilityRepTitle'
)
export const setCrew = makeActionCreator(SignaturesConstants.SET_CREW, 'crew')
export const setSectionTwoReasonIncapableOfSigning = makeActionCreator(
  SignaturesConstants.SET_SECTION_TWO_REASON_INCAPABLE_OF_SIGNING,
  'sectionTwoReasonIncapableOfSigning'
)
export const setSectionTwoSelectedOptionIncapableOfSigning = makeActionCreator(
  SignaturesConstants.SET_SECTION_TWO_SELECTED_OPTION_INCAPABLE_OF_SIGNING,
  'sectionTwoSelectedOptionIncapableOfSigning'
)
export const setSectionThreeReasonIncapableOfSigning = makeActionCreator(
  SignaturesConstants.SET_SECTION_THREE_REASON_INCAPABLE_OF_SIGNING,
  'sectionThreeReasonIncapableOfSigning'
)
export const setSectionThreeSelectedOptionIncapableOfSigning = makeActionCreator(
  SignaturesConstants.SET_SECTION_THREE_SELECTED_OPTION_INCAPABLE_OF_SIGNING,
  'sectionThreeSelectedOptionIncapableOfSigning'
)
export const setSectionTwoAuthorizedRepresentative = makeActionCreator(
  SignaturesConstants.SET_SECTION_TWO_AUTHORIZED_REPRESENTATIVE,
  'sectionTwoAuthorizedRepresentative'
)
export const saveSignaturesPcr = makeActionCreator(SignaturesConstants.SAVE_SIGNATURES_PCR)
export const saveAttachment = makeActionCreator(SignaturesConstants.SAVE_ATTACHMENT)
export const setSignatures = makeActionCreator(SignaturesConstants.SET_SIGNATURES, 'signatures')
export const saveSignatureOnClick = makeActionCreator(
  SignaturesConstants.SAVE_SIGNATURE_ON_CLICK,
  'saveSignatureOnSaveClick'
)
export const setIsSectionLockedFlag = makeActionCreator(
  SignaturesConstants.SET_IS_SECTION_LOCKED_FLAG,
  'isSectionLockedFlag'
)
export const clearSignatureState = makeActionCreator(SignaturesConstants.CLEAR_SIGNATURE_STATE)
export const deleteAllSignatureData = makeActionCreator(SignaturesConstants.DELETE_ALL_SIGNATURE_DATA)
export const setClearSignatureSectionOnClick = makeActionCreator(
  SignaturesConstants.CLEAR_SIGNATURE_SECTION_ON_CLICK,
  'clearSignatureSectionOnClick'
)
export const setAmbulanceSignatureDt = makeActionCreator(
  SignaturesConstants.SET_AMBULANCE_SIGNATURE_DT,
  'ambulanceSignatureDt'
)
export const setPatientSignatureDt = makeActionCreator(
  SignaturesConstants.SET_PATIENT_SIGNATURE_DT,
  'patientSignatureDt'
)
export const setWitnessSignatureDt = makeActionCreator(
  SignaturesConstants.SET_WITNESS_SIGNATURE_DT,
  'witnessSignatureDt'
)
export const setRepresentativeSignatureDt = makeActionCreator(
  SignaturesConstants.SET_REPRESENTATIVE_SIGNATURE_DT,
  'representativeSignatureDt'
)
export const setCrewSignatureDt = makeActionCreator(SignaturesConstants.SET_CREW_SIGNATURE_DT, 'crewSignatureDt')
export const setReceivingFacilitySignatureDt = makeActionCreator(
  SignaturesConstants.SET_RECEIVING_FACILITY_SIGNATURE_DT,
  'receivingFacilitySignatureDt'
)
export const setAcknowledgePrivacyNotice = makeActionCreator(
  SignaturesConstants.SET_SELECTED_CHECKBOX,
  'acknowledgePrivacyNotice'
)
export const setUpdatedTermsText = makeActionCreator(SignaturesConstants.SET_UPDATED_TERMS, 'updatedTerms')
export const setAcknowledgmentText = makeActionCreator(
  SignaturesConstants.SET_UPDATED_ACKNOWLEDGEMENT,
  'acknowledgmentText'
)
export const setSectionIHeaderText = makeActionCreator(SignaturesConstants.SET_SECTION_I_HEADERTEXT, 'headertext')
export const setSectionIIHeaderText = makeActionCreator(SignaturesConstants.SET_SECTION_II_HEADERTEXT, 'headertext')
export const setSectionIIIHeaderText = makeActionCreator(SignaturesConstants.SET_SECTION_III_HEADERTEXT, 'headertext')
export const setSignatureChips = makeActionCreator(SignaturesConstants.SET_SIGNATURE_CHIP, 'chips')
export const loadSignatureData = makeActionCreator(SignaturesConstants.LOAD_SIGNATURE_DATA, 'currentSelectedChip')
export const showAttachments = makeActionCreator(SignaturesConstants.SHOW_ATTACHMENTS, 'showAttachments')
export const clearSignaturesTempState = makeActionCreator(SignaturesConstants.CLEAR_SIGNATURE_TEMP_STATE)
export const clearSignatureData = makeActionCreator(SignaturesConstants.CLEAR_SIGNATURE_DATA)
export const saveSignatureChipsData = makeActionCreator(SignaturesConstants.SAVE_SIGNATURE_CHIPS_DATA)
